// extracted by mini-css-extract-plugin
module.exports = {"LoaderContainer":"loaderScreen_LoaderContainer__1ZhnM","Loader":"loaderScreen_Loader__1n7E1","load5":"loaderScreen_load5__3Uzn3"};